import { render, staticRenderFns } from "./CompraPedidoHeader.vue?vue&type=template&id=192f7670"
import script from "./CompraPedidoHeader.vue?vue&type=script&lang=js"
export * from "./CompraPedidoHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports